import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, ShoppingCart, Menu, X, User, MapPin, Phone } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    itemCount,
    setIsCartOpen
  } = useCart();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const navLinks = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Productos',
    path: '/catalogo'
  }, {
    name: 'Servicios',
    path: '/servicios'
  }, {
    name: 'Nosotros',
    path: '/nosotros'
  }, {
    name: 'Contacto',
    path: '/contacto'
  }];
  return <header className="sticky top-0 z-30 w-full bg-white" data-id="element-164">
      {/* Top Bar - Minimal */}
      <div className="bg-[#0056b3] text-white py-1.5 px-4 text-xs" data-id="element-165">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-166">
          <div className="flex items-center gap-6" data-id="element-167">
            <span className="flex items-center gap-1.5" data-id="element-168">
              <MapPin className="w-3 h-3" data-id="element-169" />
              Caracas, Venezuela
            </span>
            <span className="hidden sm:flex items-center gap-1.5" data-id="element-170">
              <Phone className="w-3 h-3" data-id="element-171" />
              +58 412-4279146
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-172">
            <Link to="/contacto" className="hover:underline" data-id="element-173">
              Ayuda
            </Link>
            <Link to="/login" className="hover:underline" data-id="element-174">
              Iniciar Sesión
            </Link>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="py-3 px-4 border-b border-gray-100" data-id="element-175">
        <div className="max-w-7xl mx-auto flex items-center gap-6" data-id="element-176">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/hYisivs9KHVbNKgWAv2Grq/420963685_924546946010783_2955376449317955242_n.jpg" alt="Materiales Brasil" className="h-12 w-auto object-contain" data-id="element-178" />
          </Link>

          {/* Search Bar - Prominent */}
          <div className="hidden md:flex flex-1 max-w-2xl" data-id="element-179">
            <div className="relative w-full flex" data-id="element-180">
              <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Buscar herramientas, cerraduras, materiales..." className="w-full pl-4 pr-12 py-2.5 border-2 border-[#0056b3] rounded-l-md focus:outline-none text-sm" data-id="element-181" />
              <button className="px-4 bg-[#0056b3] text-white rounded-r-md hover:bg-[#004494] transition-colors" data-id="element-182">
                <Search className="w-5 h-5" data-id="element-183" />
              </button>
            </div>
          </div>

          {/* Right Icons */}
          <div className="flex items-center gap-4 ml-auto" data-id="element-184">
            <Link to="/login" className="hidden md:flex items-center gap-2 text-gray-600 hover:text-[#0056b3] transition-colors" data-id="element-185">
              <User className="w-5 h-5" data-id="element-186" />
              <span className="text-sm" data-id="element-187">Mi Cuenta</span>
            </Link>

            <button onClick={() => setIsCartOpen(true)} className="relative flex items-center gap-2 text-gray-600 hover:text-[#0056b3] transition-colors" data-id="element-188">
              <ShoppingCart className="w-5 h-5" data-id="element-189" />
              <span className="hidden md:inline text-sm" data-id="element-190">Carrito</span>
              {itemCount > 0 && <span className="absolute -top-2 -right-2 md:relative md:top-0 md:right-0 bg-[#e53935] text-white text-xs font-bold min-w-[20px] h-5 rounded-full flex items-center justify-center px-1" data-id="element-191">
                  {itemCount}
                </span>}
            </button>

            <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMobileMenuOpen(true)} data-id="element-192">
              <Menu className="w-6 h-6" data-id="element-193" />
            </button>
          </div>
        </div>
      </div>

      {/* Navigation - Clean */}
      <nav className="hidden md:block bg-white border-b border-gray-100" data-id="element-194">
        <div className="max-w-7xl mx-auto px-4" data-id="element-195">
          <ul className="flex items-center gap-1" data-id="element-196">
            {navLinks.map(link => <li key={link.name} data-id="element-197">
                <Link to={link.path} className={`block px-4 py-3 text-sm font-medium transition-colors border-b-2 ${location.pathname === link.path ? 'text-[#0056b3] border-[#0056b3]' : 'text-gray-600 border-transparent hover:text-[#0056b3] hover:border-[#0056b3]'}`} data-id="element-198">
                  {link.name}
                </Link>
              </li>)}
          </ul>
        </div>
      </nav>

      {/* Mobile Search */}
      <div className="md:hidden px-4 py-2 bg-gray-50 border-b" data-id="element-199">
        <div className="relative flex" data-id="element-200">
          <input type="text" placeholder="Buscar productos..." className="w-full pl-4 pr-12 py-2 border border-gray-200 rounded-l-md focus:outline-none focus:border-[#0056b3] text-sm" data-id="element-201" />
          <button className="px-3 bg-[#0056b3] text-white rounded-r-md" data-id="element-202">
            <Search className="w-4 h-4" data-id="element-203" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-204">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 0.5
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 bg-black z-40 md:hidden" data-id="element-205" />
            <motion.div initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed left-0 top-0 h-full w-[85%] max-w-sm bg-white z-50 md:hidden flex flex-col" data-id="element-206">
              <div className="p-4 border-b flex justify-between items-center" data-id="element-207">
                <img src="https://cdn.magicpatterns.com/uploads/hYisivs9KHVbNKgWAv2Grq/420963685_924546946010783_2955376449317955242_n.jpg" alt="Materiales Brasil" className="h-10 w-auto" data-id="element-208" />
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2" data-id="element-209">
                  <X className="w-6 h-6 text-gray-500" data-id="element-210" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto" data-id="element-211">
                <ul data-id="element-212">
                  {navLinks.map(link => <li key={link.name} className="border-b border-gray-100" data-id="element-213">
                      <Link to={link.path} onClick={() => setIsMobileMenuOpen(false)} className={`block px-6 py-4 text-base ${location.pathname === link.path ? 'text-[#0056b3] bg-blue-50 font-medium' : 'text-gray-700'}`} data-id="element-214">
                        {link.name}
                      </Link>
                    </li>)}
                </ul>
              </div>

              <div className="p-4 border-t bg-gray-50" data-id="element-215">
                <Link to="/login" className="flex items-center justify-center gap-2 w-full py-3 bg-[#0056b3] text-white rounded-md font-medium" data-id="element-216">
                  <User className="w-5 h-5" data-id="element-217" />
                  Iniciar Sesión
                </Link>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </header>;
}